module.exports = __webpack_public_path__ + "fonts/be-vietnam-pro-v8-latin-regular.b2ad12d.woff";